module.exports = __webpack_public_path__ + "img/microgaming.9dfc3d7c.jpg";